export * from "@/ui/components/data-display/HeadedSection/HeadedSection";
export * from "@/ui/components/data-display/HeadedSection/HeadedSection.config";
export * from "@/ui/components/data-display/HeadedSection/HeadedSectionContent";
export * from "@/ui/components/data-display/HeadedSection/HeadedSectionHeader";
